// 自动生成文件 切勿改动!

export const projectName = 'company-management'
export const dvaNamespacePrefix = 'companyManagement'
